import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translation from '../../i18n/Translation';
import WhatNextBanner from '../WhatNextBanner';
import { getLatestHistoryItem } from '../selectors';

export const Pending = ({ pendingWithdrawal }) => (
  <div className="withdraw-result">
    <h1 className="withdraw-result__status withdraw-result__status--success">
      <div className="withdraw-result__status-icon">
        <i className="withdraw-result__status-circle">
          <i className="material-icon material-icon--check" />
        </i>
      </div>
      <Translation section="withdraw" label="pendingTitle" />
    </h1>
    <p className="withdraw-result__info">
      <Translation
        section="withdraw"
        label="pendingInfo"
        variables={{ value: `£${pendingWithdrawal.amount}`, date: pendingWithdrawal.datetime }}
      />
    </p>
    <WhatNextBanner />
  </div>
);

Pending.propTypes = {
  pendingWithdrawal: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  pendingWithdrawal: getLatestHistoryItem(state)
});

export default connect(mapStateToProps)(Pending);
